/**
 * Функции анализа и отладки AMO полей
 * Предоставляет высокоуровневые функции для диагностики полей
 */

import { baseDebugFunction } from './amoFieldsDebugCore.js';
import { findFieldContainer, getAmoAttributes } from './amoFieldsUtilsHelpers.js';

/**
 * Отладочная функция для анализа DOM структуры AMO полей
 * @param {string|number} fieldId - ID поля для анализа
 * @returns {Object} Информация о найденных элементах
 */
export function debugAmoField(fieldId) {
    const result = baseDebugFunction(fieldId, 'field');
    
    const { attributes, cfvKey } = getAmoAttributes(fieldId);
    if (attributes) {
        result.amoAttributes = {
            [cfvKey]: attributes[cfvKey],
            allCFVKeys: Object.keys(attributes)
                .filter(key => key.startsWith('CFV['))
        };
        
        const multiselectKeys = Object.keys(attributes)
            .filter(key => key.startsWith(`CFV[${fieldId}][`));
        
        if (multiselectKeys.length > 0) {
            result.multiselectInfo = {
                enumKeys: multiselectKeys,
                enumValues: {}
            };
            
            multiselectKeys.forEach(key => {
                result.multiselectInfo.enumValues[key] = attributes[key];
            });
            
            const amoFields = AMOCRM.constant("account").cf || {};
            const field = amoFields[fieldId];
            if (field) {
                result.multiselectInfo.fieldInfo = {
                    name: field.NAME,
                    type: field.TYPE_CODE,
                    typeId: field.TYPE_ID,
                    enums: field.ENUMS
                };
            }
        }
    }
    
    console.log('Отладка AMO поля:', result);
    return result;
}

/**
 * Отладочная функция для проверки состояния мультиселекта
 * @param {string|number} fieldId - ID мультиселекта
 */
export function debugMultiselectState(fieldId) {
    const result = baseDebugFunction(fieldId, 'state');
    
    console.log(`=== Отладка мультиселекта ${fieldId} ===`);
    if (result.error) {
        console.log('Ошибка:', result.error);
        return result;
    }
    
    console.log('Основное поле:', `CFV[${fieldId}]`, '=', result.mainFieldValue);
    console.log('Текущее значение через getCurrentAmoFieldValue:', result.currentValue);
    
    if (result.enumValues && Object.keys(result.enumValues).length > 0) {
        console.log('Enum значения:');
        Object.entries(result.enumValues).forEach(([enumId, enumInfo]) => {
            console.log(`  ${enumInfo.key} = "${enumInfo.value}" (${enumInfo.text}) - ${enumInfo.selected ? 'ВЫБРАНО' : 'НЕ ВЫБРАНО'}`);
        });
    }
    
    console.log('=== Конец отладки ===');
    return result;
}

/**
 * Отладочная функция для анализа HTML структуры мультиселекта
 * @param {string|number} fieldId - ID мультиселекта
 */
export function debugMultiselectHTML(fieldId) {
    const result = baseDebugFunction(fieldId, 'html');
    
    console.log('=== Отладка HTML структуры мультиселекта ===');
    if (result.error) {
        console.log('Ошибка:', result.error);
        return result;
    }
    
    const { element: fieldContainer } = findFieldContainer(fieldId);
    if (fieldContainer) {
        result.structure = {
            dropdown: !!fieldContainer.querySelector('.checkboxes_dropdown'),
            dropdown_content: !!fieldContainer.querySelector('.checkboxes_dropdown__content'),
            items_container: !!fieldContainer.querySelector('.checkboxes_dropdown__items'),
            master_wrapper: !!fieldContainer.querySelector('.js-master-checkbox-wrapper')
        };
    }
    
    console.log(result);
    console.log('=== Конец отладки ===');
    
    return result;
} 